const initialState = {
    data: [],
    dataview:[],
  };
  
  const DneedReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
        case 'FETCH_VIEW_DATA_SUCCESS':
        return{ ...state, dataview: action.payload }
      default:
        return state;
    }
  };
  
  export default DneedReducer;
  
  